<template >
  <v-container grid-list-lg>
    <form>
      <v-layout column>
        <v-flex v-if="!organization">
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.ownerInformation') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field label="First Name *" v-model="Store.ownerName"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Last Name *" v-model="Store.ownerLastName"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Login Email *" v-model="Store.loginEmail"
                      :error-messages="loginEmailErrors"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field label="Password" v-model="Store.loginPassword" :error-messages="loginPasswordErrors"
                      type="password"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex v-else>
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.ownerInformation') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex class="display-1" xs12>{{ organization.organizationName }}</v-flex>
                  </v-layout>
                  <v-layout class="pt-0" row wrap>
                    <v-flex class="title" xs12>{{ organization.ownerName }} | {{ organization.primaryPhone | USPhoneNumber
                    }}</v-flex>
                  </v-layout>
                  <v-layout class="pt-0" row wrap>
                    <v-flex class="subheading" xs12>Login Email: {{ organization.loginEmail }}</v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.NewLocation') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field label="Store Name" v-model="Store.businessName"
                        :error-messages="businessNameErrors"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field label="Address" v-model="Store.address"
                        :error-messages="businessAddressErrors"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm3="sm3">
                      <v-text-field label="City" v-model="Store.city" :error-messages="businessCityErrors"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3="sm3">
                      <v-autocomplete v-model="Store.stateID" :items="states" autocomplete="off"
                        :error-messages="stateErrors" :filter="customFilter" item-text="stateName" item-value="stateID"
                        label="State"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm3="sm3">
                      <v-text-field label="Zipcode" v-model="Store.zipCode"
                        :error-messages="businessZipcodeErrors"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3="sm3">
                      <v-text-field label="Country" v-model="Store.country"
                        :error-messages="businessCountryErrors"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-autocomplete :items="comboBoxByID(12).ComboBoxDetails" :label="$t('labels.businessType')"
                        item-text="selector" :error-messages="businessTypeErrors" item-value="id"
                        v-model="Store.businessTypeID"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-autocomplete :items="comboBoxByID(13).ComboBoxDetails" :label="$t('labels.howDidYouFindUs')"
                        item-text="selector" :error-messages="findUsErrors" item-value="id"
                        v-model="Store.findUsID"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.contactInformation') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex xs12 sm4>
                      <v-text-field label="Phone Number" v-model="Store.businessPhone"
                        :error-messages="businessPhoneNumberErrors"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field label="Cell Phone Number" v-model="Store.cellPhone"
                        :error-messages="cellPhoneNumberErrors"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field label="Business Email" v-model="Store.businessEmail"
                        :error-messages="businessEmailErrors"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field label="Invoice Email" v-model="Store.invoiceEmail"
                        :error-messages="businessInvoiceEmailErrors"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex v-if="!organization">
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.securityPinNumber') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout row align-center="align-center" justify-center="justify-center" fill-height="fill-height" wrap>
                  <v-layout column>
                    <v-flex class="text-xs-center">Setup a 4 digits pin number</v-flex>
                    <v-flex class="text-xs-center">If you setup pin any time big changes require to a database or
                      software. rep will ask for this pin number.</v-flex>
                    <v-flex xs12>
                      <v-text-field label="Pin Number" v-model="Store.pinNumber"
                        :error-messages="pinNumberErrors"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('labels.service') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-autocomplete :items="services" :label="$t('labels.service')" return-object="return-object"
                  item-text="selector" :error-messages="serviceErrors" v-model="selectedService"
                  item-value="id"></v-autocomplete>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex v-if="selectedService">
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t('pageHeader.plans') }}</h1>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex v-if="selectedService.id === 192">
                      <v-autocomplete :items="comboBoxByID(3).ComboBoxDetails" :label="$t('labels.software')"
                        item-text="selector" item-value="id" v-model="Store.cSoftwareID"></v-autocomplete>
                    </v-flex>
                    <v-flex>
                      <v-autocomplete :items="plan" :label="$t('labels.plan')" item-text="productDetail"
                        @change="changePlan" item-value="productID" :error-messages="productErrors"
                        v-model="Store.productID"></v-autocomplete>
                    </v-flex>
                    <v-flex>
                      <v-text-field class="right-input" label="Fee *" v-model="Store.softwareFee"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card>
            <v-card-text>
              <v-container>
                <v-layout row>
                  <v-btn color="info" flat="flat" @click="close">{{ $t('buttons.back') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="info" @click="save" :loading="loading">{{ $t('buttons.placeOrder') }}</v-btn>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { SERVICE } from '../../../../helper/Constant.js'
import locationService from '../service'
import organizationService from '../../Organization/service'
import Address from '../../Global/components/Address'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
  maxLength,
  email,
} = require('vuelidate/lib/validators')
export default {
  data() {
    return {
      id: null,
      selectedService: null,
      selectedPlan: null,
      plan: null,
      organization: null,
      services: [],
      Store: {
        latitude: null,
        longitude: null,
        ownerName: null,
        ownerLastName: null,
        loginEmail: null,
        loginPassword: null,
        businessName: null,
        businessPhone: null,
        businessEmail: null,
        cellPhone: null,
        address: null,
        city: null,
        stateID: null,
        zipCode: null,
        country: null,
        softwareFee: 0,
        productID: null,
        cSoftwareID: null,
        invoiceEmail: null,
        businessTypeID: null,
        findUsID: null,
        pinNumber: null,
        smsRate: 0.02,
        mmsRate: 0.05,
      },
      loading: false,
    }
  },
  components: {
    Address,
  },
  mixins: [validationMixin],
  validations() {
    if (this.id !== 0) {
      return {
        selectedService: {
          required,
        },
        Store: {
          pinNumber: {
            minLength: minLength(4),
            maxLength: maxLength(4),
          },
          businessName: {
            required,
            minLength: minLength(4),
          },
          businessPhone: {
            required,
          },
          cellPhone: {
            required,
          },
          findUsID: {
            minValue: minValue(1),
          },
          businessTypeID: {
            minValue: minValue(1),
          },
          // cSoftwareID: {
          //   required,
          //   minValue: minValue(1),
          // },
          productID: {
            required,
            minValue: minValue(1),
          },
          address: {
            required,
            minLength: minLength(10),
          },
          city: {
            required,
            minLength: minLength(2),
          },
          stateID: {
            required,
            minValue: minValue(1),
          },
          zipCode: {
            required
          },
          country: {
            required,
            minLength: minLength(4)
          },
          businessEmail: {
            required,
            email,
          },
          invoiceEmail: {
            required,
            email,
          },
        },
      }
    } else {
      return {
        selectedService: {
          required,
        },
        Store: {
          pinNumber: {
            minLength: minLength(4),
            maxLength: maxLength(4),
          },
          ownerName: {
            required,
          },
          ownerLastName: {
            required,
          },
          loginEmail: {
            required,
            email,
          },
          loginPassword: {
            required,
            minLength: minLength(4),
          },
          businessName: {
            required,
            minLength: minLength(4),
          },
          businessPhone: {
            required,
          },
          cellPhone: {
            required,
          },
          findUsID: {
            minValue: minValue(1),
          },
          businessTypeID: {
            minValue: minValue(1),
          },
          // cSoftwareID: {
          //   required,
          //   minValue: minValue(1),
          // },
          productID: {
            required,
            minValue: minValue(1),
          },
          address: {
            required,
            minLength: minLength(10),
          },
          city: {
            required,
            minLength: minLength(2),
          },
          stateID: {
            required,
            minValue: minValue(1),
          },
          zipCode: {
            required
          },
          country: {
            required,
            minLength: minLength(4)
          },
          businessEmail: {
            required,
            email,
          },
          invoiceEmail: {
            required,
            email,
          },
        },
      }
    }
  },
  watch: {
    selectedService() {
      console.log('selecte service change')
      this.getServiceProduct()
    }
  },
  async mounted() {
    await this.filterService()
  },
  async created() {
    if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.id = this.$route.params.id
    if (this.id !== '0') {
      organizationService.getById(this.id)
        .then(result => {
          this.organization = result.data
        })
    }
    this.$store.dispatch('global/initModules')
    await this.filterService()
  },
  computed: {
    ...mapGetters('global', ['states', 'comboBox', 'modules', 'comboBoxByID', 'currentUser']),
    buildValue() {
      let amount = 0
      this.Plans.selectedModules.forEach(plan => {
        this.modules.forEach(module => {
          if (module.moduleId === plan) {
            amount = amount + module.price
          }
        })
      })
      return amount
    },
    serviceErrors() {
      const errors = []
      if (!this.$v.selectedService.$dirty) return errors
      if (!this.$v.selectedService.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    productErrors() {
      const errors = []
      if (!this.$v.Store.productID.$dirty) return errors
      if (!this.$v.Store.productID.minValue) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    stateErrors() {
      const errors = []
      if (!this.$v.Store.stateID.$dirty) return errors
      if (!this.$v.Store.stateID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.stateID.minValue) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    findUsErrors() {
      const errors = []
      if (!this.$v.Store.findUsID.$dirty) return errors
      if (!this.$v.Store.findUsID.minValue) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    businessTypeErrors() {
      const errors = []
      if (!this.$v.Store.businessTypeID.$dirty) return errors
      if (!this.$v.Store.businessTypeID.minValue) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    softwareErrors() {
      const errors = []
      if (!this.$v.Store.cSoftwareID.$dirty) return errors
      if (!this.$v.Store.cSoftwareID.minValue) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    pinNumberErrors() {
      const errors = []
      if (!this.$v.Store.pinNumber.$dirty) return errors
      if (!this.$v.Store.pinNumber.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      if (!this.$v.Store.pinNumber.maxLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    businessNameErrors() {
      const errors = []
      if (!this.$v.Store.businessName.$dirty) return errors
      if (!this.$v.Store.businessName.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.businessName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    ownerNameErrors() {
      const errors = []
      if (this.id === 0) {
        if (!this.$v.Store.ownerName.$dirty) return errors
        if (!this.$v.Store.ownerName.required) errors.push(this.$t('validations.fieldIsRequired'))
      }
      return errors
    },
    ownerLastNameErrors() {
      const errors = []
      if (this.id === 0) {
        if (!this.$v.Store.ownerLastName.$dirty) return errors
        if (!this.$v.Store.ownerLastName.required) errors.push(this.$t('validations.fieldIsRequired'))
      }
      return errors
    },
    loginEmailErrors() {
      const errors = []
      if (this.id === 0) {
        if (!this.$v.Store.loginEmail.$dirty) return errors
        if (!this.$v.Store.loginEmail.required) errors.push(this.$t('validations.fieldIsRequired'))
        if (!this.$v.Store.loginEmail.email) errors.push(this.$t('validations.emailIsNotValid'))
      }
      return errors
    },
    loginPasswordErrors() {
      const errors = []
      if (this.id === 0) {
        if (!this.$v.Store.loginPassword.$dirty) return errors
        if (!this.$v.Store.loginPassword.required) errors.push(this.$t('validations.fieldIsRequired'))
        if (!this.$v.Store.loginPassword.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      }
      return errors
    },
    businessPhoneNumberErrors() {
      const errors = []
      if (!this.$v.Store.businessPhone.$dirty) return errors
      if (!this.$v.Store.businessPhone.required) errors.push(this.$t('validations.phoneNumberIsRequired'))
      return errors
    },
    cellPhoneNumberErrors() {
      const errors = []
      if (!this.$v.Store.cellPhone.$dirty) return errors
      if (!this.$v.Store.cellPhone.required) errors.push(this.$t('validations.phoneNumberIsRequired'))
      return errors
    },
    businessAddressErrors() {
      const errors = []
      if (!this.$v.Store.address.$dirty) return errors
      if (!this.$v.Store.address.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.address.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))

      return errors
    },
    businessCityErrors() {
      const errors = []
      if (!this.$v.Store.city.$dirty) return errors
      if (!this.$v.Store.city.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.city.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    businessStateErrors() {
      const errors = []
      if (!this.$v.Store.StateId.$dirty) return errors
      if (!this.$v.Store.StateId.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    businessZipcodeErrors() {
      const errors = []
      if (!this.$v.Store.zipCode.$dirty) return errors
      if (!this.$v.Store.zipCode.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    businessCountryErrors() {
      const errors = []
      if (!this.$v.Store.country.$dirty) return errors
      if (!this.$v.Store.country.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.country.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    businessEmailErrors() {
      const errors = []
      if (!this.$v.Store.businessEmail.$dirty) return errors
      if (!this.$v.Store.businessEmail.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.businessEmail.email) errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    businessInvoiceEmailErrors() {
      const errors = []
      if (!this.$v.Store.invoiceEmail.$dirty) return errors
      if (!this.$v.Store.invoiceEmail.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Store.invoiceEmail.email) errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
  },
  methods: {
    ...mapActions("global", ["setLoadingStatus"]),
    close() {
      this.$router.go(-1)
    },
    filterService() {
      this.services = this.comboBoxByID(28).ComboBoxDetails.filter(service => service.id !== SERVICE.CSP4.ID)
    },
    // setAddress(val) {
    //   this.Store.zipCode = val.zipCode
    //   this.Store.city = val.city
    //   this.Store.country = val.country
    //   this.Store.address = val.address
    //   this.Store.latitude = val.latitude
    //   this.Store.longitude = val.longitude
    //   this.Store.stateID = val.stateID
    // },
    changePlan(e) {
      let product = null
      this.plan.map(x => {
        if (x.productID === e) {
          product = x
        }
      })
      this.Store.softwareFee = product.amount
    },
    getServiceProduct() {
      locationService.getServiceProduct(this.selectedService.id)
        .then(result => {
          this.plan = result.data
        })
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.stateName.toLowerCase()
      const textTwo = item.stateSymbol.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        this.setLoadingStatus({
          status: true,
          title: 'Creating Location...'
        })
        // this.loading = true
        this.Store.shipName = this.Store.businessName
        this.Store.shipBusinessName = this.Store.businessName
        this.Store.shipAddress = this.Store.address
        this.Store.shipCity = this.Store.city
        this.Store.shipState = this.Store.stateID
        this.Store.shipZipcode = this.Store.zipCode
        this.Store.shipCountry = this.Store.country
        this.Store.shipPhone = this.Store.businessPhone
        this.Store.serviceID = this.selectedService.id
        this.Store.serviceName = this.selectedService.selector
        // console.log('this.Store', this.Store)
        return locationService.addLocation(this.id, this.Store)
          .then((result) => {
            console.log('location created', result)
            this.loading = false
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'success',
              title: 'Location is created'
            })
            this.setLoadingStatus({
              status: false,
              color: 'pink',
              title: 'Creating Location...'
            })
            this.$router.push({ path: `/location/profile/${result.data.store.storeID}` })
          }).catch((err) => {
            console.log('test error', err)
            this.setLoadingStatus({
              status: false,
              color: 'pink',
              title: 'Creating Location...'
            })
            this.$swal('Missing Fields', err.data.list, 'error').then(() => {
              this.loading = false
            })
          })
      }
    }
  },
}
</script>

<style scoped>.selected {
  border-width: 3px;
  border-color: orange;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
}</style>
